<template>
  <v-app id="inspire">
    <v-system-bar lights-out class="d-flex" color="branco">
      <v-spacer></v-spacer>

      <v-icon style="color:orange">mdi-account-circle-outline</v-icon>
      <span>{{ nome }}</span>

      <span class="ml-10" style="cursor:pointer;color:red" @click="logout()"
        >Sair do sistema</span
      >
      <v-icon style="color:red">mdi-exit-to-app</v-icon>
    </v-system-bar>

    <v-navigation-drawer
      class="mt-5"
      v-model="drawer"
      :clipped="$vuetify.breakpoint.lgAndUp"
      app
    >
      <v-list dense>
        <template v-for="item in items">
          <v-row v-if="item.heading" :key="item.heading" align="center">
            <v-col cols="6">
              <v-subheader v-if="item.heading">{{ item.heading }}</v-subheader>
            </v-col>
            <v-col cols="6" class="text-center">
              <a href="#!" class="body-2 black--text">EDIT</a>
            </v-col>
          </v-row>
          <v-list-group
            v-else-if="item.children"
            :key="item.text"
            v-model="item.model"
            :prepend-icon="item.model ? item.icon : item['icon-alt']"
            append-icon
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>{{ item.text }}</v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item v-for="(child, i) in item.children" :key="i" link>
              <v-list-item-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ child.text }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
          <v-list-item v-else :key="item.text" :to="item.link" link>
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ item.text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      dense
      flat
      app
      color="primary"
      class="mt-5"
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
      <v-toolbar-title class="ml-0 pl-4">
        <span class="hidden-sm-and-down">Controle de Notas</span>
      </v-toolbar-title>
      <v-spacer />
    </v-app-bar>
    <v-content>
      <v-container class="pt-0" fluid>
        <v-row>
          <router-view></router-view>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
export default {
  props: {
    source: String,
  },
  mounted() {
    this.nome = sessionStorage.getItem("nome");
    /*axios.defaults.headers.common["Authorization"] =
      "bearer " + sessionStorage.getItem("token");*/
  },
  methods: {
    logout() {
      window.sessionStorage.setItem("token", "");
      this.$router.push("/");
    },
  },
  data: () => ({
    dialog: false,
    drawer: null,
    nome: "",
    empresas: [{ text: "Empresa1" }, { text: "Tecnoweb" }],
    items: [
      /* {
        icon: "mdi-sort-descending",
        text: "Vendas Abc",
        link: "/dashboard/vendas",
      },
      {
        icon: "mdi-sort-descending",
        text: "Compras Abc",
        link: "/dashboard/compras",
      },*/
      {
        icon: "mdi-file-document-outline",
        text: "Notas de Saídas",
        link: "/dashboard/saidas",
      },
      /*
      {
        icon: "mdi-clipboard-arrow-down-outline",
        text: "Notas de Entradas",
        link: "/dashboard/entradas",
      },
      */
      { icon: "mdi-content-copy", text: "Eventos", link: "/dashboard/eventos" },
      {
        icon: "mdi-file-cancel-outline",
        text: "Inutilizadas",
        link: "/dashboard/inutilizadas",
      } /*

      {
        icon: "mdi-barcode-off",
        text: "Produtos sem GTIN",
        link: "/dashboard/produtos_sgt",
        //link: "/dashboard/produtos_sgt",
      },*/,
    ],
  }),
};
</script>
